var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreferred(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 5,
    fill: "#6764FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3248 36.2125L14.1665 23.4167L21.8748 26.5L26.4998 17.25L31.1248 26.5L38.8332 23.4167L36.6748 36.2125C36.3665 37.7542 35.1332 38.8333 33.5915 38.8333H19.254C17.8665 38.8333 16.479 37.7542 16.3248 36.2125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4998 20.3346C28.2027 20.3346 29.5832 18.9542 29.5832 17.2513C29.5832 15.5484 28.2027 14.168 26.4998 14.168C24.797 14.168 23.4165 15.5484 23.4165 17.2513C23.4165 18.9542 24.797 20.3346 26.4998 20.3346Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8333 26.4987C40.5362 26.4987 41.9167 25.1182 41.9167 23.4154C41.9167 21.7125 40.5362 20.332 38.8333 20.332C37.1305 20.332 35.75 21.7125 35.75 23.4154C35.75 25.1182 37.1305 26.4987 38.8333 26.4987Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 26.4987C15.8697 26.4987 17.2502 25.1182 17.2502 23.4154C17.2502 21.7125 15.8697 20.332 14.1668 20.332C12.464 20.332 11.0835 21.7125 11.0835 23.4154C11.0835 25.1182 12.464 26.4987 14.1668 26.4987Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferred);
export default __webpack_public_path__ + "static/media/preferred.8c9795affcab54df8e138d797d955b64.svg";
export { ForwardRef as ReactComponent };